import { CommonRiskModels } from './common-risk.models';

export namespace AddressModels {
  import AssureInfos = CommonRiskModels.AssureInfos;

  export class Address {
    streetName?: string;
    streetNumber!: number;
    streetType?: string;
    repetition?: string;
    complement?: string;
    cityName?: string;
    cityZipCode?: string;
    codeInsee?: string;

    constructor(info: AssureInfos | any) {
      this.cityName = info.address.cityName;
      this.cityZipCode = info.address.cityZipCode;
      this.complement = info.address.complement;
      this.repetition = info.address.repetition;
      this.streetName = info.address.streetName;
      this.streetNumber = info.address.streetNumber;
      this.streetType = info.address.streetType;
    }

    public static get empty(): Address {
      return {
        cityName: '',
        cityZipCode: '',
        complement: '',
        repetition: '',
        streetName: '',
        streetNumber: 0,
        streetType: '',
        codeInsee: '',
      };
    }

    formattedAddress?(): string {
      return `${this.streetNumber || ''} ${this.repetition || ''} ${this.streetType || ''} ${this.streetName}`;
    }
  }

  export interface City {
    name: string;
    postalCodes: string[];
    inseeCode: string;
  }

  export enum CitiesRepositoryEnum {
    TunnelSante = 1,
    Smalltox = 2,
  }
  export interface CityTemplateOptions {
    label: string;
    value: string;
    codePostal: string;
    inseeCode: string;
  }

  export interface GroupVille {
    codePostal?: string;
    ville?: string;
    inseeCode?: string;
  }
}
